import { useEffect, useRef } from 'react';
import IconifyIcon from '../../../../components/wrappers/IconifyIcon';
import { useLayoutContext } from '../../../../context/useLayoutContext';
import useViewPort from '../../../../hooks/useViewPort';

const HoverMenuToggle = () => {
  const { menu: { size }, changeMenu: { size: changeMenuSize } } = useLayoutContext();
  const { width } = useViewPort();
  const prevWidth = useRef(null);

  useEffect(() => {
    // Only auto-hide on genuine resize events, not on initial mount/refresh
    if (prevWidth.current !== null && prevWidth.current > 768 && width <= 768 && size !== 'hidden') {
      changeMenuSize('hidden');
    }
    if (prevWidth.current !== null && prevWidth.current <= 768 && width > 768 && size === 'hidden') {
      changeMenuSize('sm-hover-active');
    }
    prevWidth.current = width;
  }, [width]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = () => {
    if (size === 'condensed') changeMenuSize('sm-hover-active');
    else changeMenuSize('condensed');
  };

  return (
    <button
      type="button"
      className="sidebar-toggle-btn"
      aria-label={size === 'condensed' ? 'Expand sidebar' : 'Collapse sidebar'}
      onClick={handleClick}
    >
      <span className="sidebar-toggle-btn-inner">
        <IconifyIcon
          icon={size === 'condensed' ? 'bx:chevron-right' : 'bx:chevron-left'}
          className="sidebar-toggle-arrow"
        />
      </span>
    </button>
  );
};

export default HoverMenuToggle;
